/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-runloop, ember/require-tagless-components */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { bind } from '@ember/runloop';
import { service } from '@ember/service';
import MediaSource from '@linc-technologies/linced-common/enums/media-source';
import MediaType from '@linc-technologies/linced-common/enums/media-type';
import StreamSource from '@linc-technologies/linced-common/enums/stream-source';
import { classNames } from '@ember-decorators/component';

/* global Hammer */

@classNames('post-gallery')
export default class PostGallery extends Component {
  @service
  inViewport;

  MediaSource = MediaSource;
  MediaType = MediaType;
  StreamSource = StreamSource;
  media = [];
  @tracked
  pos = 0;
  @tracked
  hasEnteredViewport = false;

  @tracked
  active;

  _setupHammer() {
    // Enable swipe-based gallery navigation
    let hammer = new Hammer.Manager(this.element, {
      dragLockToAxis: true,
      dragBlockHorizontal: true,
      recognizers: [
        [
          Hammer.Swipe,
          { direction: Hammer.DIRECTION_HORIZONTAL, threshold: 10 },
        ],
      ],
    });
    hammer
      .on('swiperight', bind(this, this.prev))
      .on('swipeleft', bind(this, this.next));
    this._hammer = hammer;
  }

  @action
  handlePrev() {
    this.prev();
  }

  prev() {
    let pos = this.pos;
    let media = this.media;
    if (pos > 0) {
      this.active = media[--pos];
      this.pos = pos;
    } else {
      // Loop around to the last item "before" the first one.
      this.active = media[media.length - 1];
      this.pos = media.length - 1;
    }
  }

  @action
  next() {
    let media = this.media;
    let pos = this.pos;
    if (++pos < media.length) {
      this.active = media[pos];
      this.pos = pos;
    } else {
      // Loop back to the first item at the end.
      this.active = media[0];
      this.pos = 0;
    }
  }

  didInsertElement() {
    super.didInsertElement(...arguments);
    this._setupHammer();

    const { onEnter } = this.inViewport.watchElement(this.element);
    onEnter(this.didEnterViewport.bind(this));
  }

  willDestroy() {
    this.inViewport.stopWatching(this.element);
    super.willDestroy(...arguments);
  }

  didEnterViewport() {
    this.hasEnteredViewport = true;
    this.inViewport.stopWatching(this.element);
  }
}
